import React, { useState } from 'react';
import { TypographyH2, TypographyP } from '@/Components/shadcn';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/Components/shadcn/tabs';
import TemplateEditor from './TemplateEditor';
import { EmailTemplateType } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';
import ExitDialog from '../ExitDialog';
import { useAccountSettings } from '@/api/useAccountSettings';

const INVITE_TAB = '1';
const REJECT_TAB = '2';

function EditEmailTemplate(): React.JSX.Element {
    const { data: accountSettings } = useAccountSettings();

    const [value, setValue] = useState(INVITE_TAB);
    const [newValue, setNewValue] = useState('');
    const [dirty, setDirty] = useState(false);
    const [open, setOpen] = useState(false);

    const handleValueChange = (next: string) => {
        if (dirty && next !== value) {
            setNewValue(next);
            setOpen(true);
            return;
        }
        setValue(next);
    };

    return (
        <div className="flex flex-col items-start justify-start gap-6">
            <div className="flex flex-col gap-2">
                <TypographyH2>{UIStrings.EmailTemplates}</TypographyH2>
                <TypographyP>{UIStrings.ManageInterviewInvitation}</TypographyP>
            </div>

            <div className="w-full">
                <Tabs value={value} onValueChange={handleValueChange} className="w-full gap-0">
                    <TabsList
                        variant="line-primary"
                        className="border-border bg-card w-full min-w-0 flex-nowrap justify-start overflow-x-auto rounded-t-xl border-b"
                        aria-label={UIStrings.EmailTemplates}
                    >
                        <TabsTrigger value={INVITE_TAB}>{UIStrings.InterviewInvitationEmail}</TabsTrigger>
                        <TabsTrigger value={REJECT_TAB}>{UIStrings.RejectionEmail}</TabsTrigger>
                    </TabsList>

                    <TabsContent value={INVITE_TAB}>
                        <div className="pt-6 md:pt-8">
                            <TemplateEditor
                                setDirty={setDirty}
                                {...accountSettings.inviteEmailTemplate}
                                templateType={EmailTemplateType.InviteTemplate}
                            />
                        </div>
                    </TabsContent>
                    <TabsContent value={REJECT_TAB}>
                        <div className="pt-6 md:pt-8">
                            <TemplateEditor
                                setDirty={setDirty}
                                {...accountSettings.rejectEmailTemplate}
                                templateType={EmailTemplateType.RejectTemplate}
                            />
                        </div>
                    </TabsContent>
                </Tabs>
            </div>
            <ExitDialog
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => {
                    setOpen(false);
                    setValue(newValue);
                    setDirty(false);
                }}
            />
        </div>
    );
}

export default EditEmailTemplate;
